import styled from 'styled-components';

export default function Image({ id: buttonId, value, label, format, onClick, imageLink = '' }) {
	if (!value || !value.length) {
		return false;
	}

	function doOnClick(e) {
		onClick(e, buttonId);
	}

	format = format ? format : '';

	return (
		<StyledWrapper
			className={`slp-Image  slp-Section ${'full-width' !== format ? 'container' : ''}`}
		>
			<p>
				<img
					src={value}
					href={imageLink ? imageLink : null}
					onClick={imageLink ? doOnClick : null}
					style={{
						cursor: imageLink ? 'pointer' : 'default',
						width: 'full-width' === format ? '100%' : '',
					}}
				/>
			</p>
			{label && label.length && <p>{label}</p>}
		</StyledWrapper>
	);
}

const StyledWrapper = styled.div`
	text-align: center;
`;
